import { rem } from 'polished'

const colorVars = {
  blue_light: '#4782E0',
  blue_dark: '#002868',
  red: '#BF0A30',
  white: '#ffffff',
  black: '#000000',

  // from styleguide:
  gray100: '#F6F7FA',
  gray200: '#E2E7F0',
  gray300: '#BFC9D8',
  gray400: '#A0ACBF',
  gray500: '#768397',
  gray600: '#586272',
  // not from styleguide:
  gray700: '#495057',
  gray800: '#343a40',
  gray900: '#212529',
  orange: '#E67201',
  gray: '#333333'
}

const themeVars = {
  primary: colorVars.orange,
  secondary: colorVars.gray,
  danger: colorVars.red
}

const fontVars = {
  font_color: colorVars.gray800,
  font_size: '1rem',
  font_size_xs: '0.75rem',
  font_size_sm: '0.875rem',
  font_size_lg: '1.25rem',
  font_family_base:
    '"Barlow", Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  font_family_monospace: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
}

const headingsVars = {
  h1_font_size: rem( 26 ),
  h2_font_size: rem( 22 ),
  h3_font_size: rem( 18 ),
  h4_font_size: rem( 14 ),
  h5_font_size: rem( 12 ),
  h6_font_size: rem( 10 )
}

const spacingVars = {
  spacing_extra_extra_small: '.125rem',
  spacing_extra_small: '.25rem',
  spacing_small: '.5rem',
  spacing_medium: '0.75rem',
  spacing: '1rem',
  spacing_large: '2rem',
  spacing_extra_large: '4rem',
  spacing_extra_extra_large: '8rem',
  spacing_extra_extra_extra_large: '16rem'
}

const borderVars = {
  border: `1px solid ${colorVars.gray300}`,
  border_radius: '0.25rem',
  border_radius_sm: '0.2rem',
  border_radius_lg: '0.3rem',
  border_color: `${colorVars.gray300}`,
  border_color_lighter: `${colorVars.gray200}`
}

const breakpointVars = {
  sm: '36rem',
  md: '48rem',
  lg: '62rem',
  xl: '75rem'
}

const breakpoints = {
  /**
   * These are the defaults from reflexbox (via system-ui)
   *   sm: 40em  --> 640px
   *   md: 52em  --> 832px
   *   lg: 64em  --> 1,024px
   *
   * Using defaults from bootstrap-4
   *   sm: 576px  --> 36rem
   *   md: 768px  --> 48rem
   *   lg: 992px  --> 62rem
   *   xl: 1200px --> 75rem
   **/
  breakpoints: [ breakpointVars.sm, breakpointVars.md, breakpointVars.lg, breakpointVars.xl ]
}

const containerMaxWidths = {
  /**
   * Using defaults from bootstrap-4
   *   sm: 540px  --> 33.75rem
   *   md: 720px  --> 45rem
   *   lg: 960px  --> 60rem
   *   xl: 1140px --> 71.25rem
   **/
  container_sm: '33.75rem',
  container_md: '45rem',
  container_lg: '60rem',
  container_xl: '71.25rem'
}

const systemUI = {
  /**
   * For reflexbox (via system-ui)
   * - Will probably go unused, but it's here for reference until cleanup
   *
   **/
  colors: {
    text: 'red',
    background: 'pink',
    primary: 'blue'
  },
  space: [ 0, 4, 8, 16, 32, 64, 128, 256 ]
}

const miscVars = {
  box_shadow: '0 0 8px 0 rgba(0, 0, 0, 0.14)'
}

const debug = {
  debug: `border: 1px solid ${themeVars.danger};`
}

// FLAG - Cleanup internally used objects from this export
export const vars = {
  ...colorVars,
  ...themeVars,
  ...spacingVars,
  ...borderVars,
  ...fontVars,
  ...headingsVars,
  ...breakpointVars,
  ...containerMaxWidths,
  ...breakpoints,
  ...systemUI,
  ...miscVars,
  ...debug
}

export default vars